import classNames from "classnames";

import styles from "../StatusPageConsumption.module.scss";

export const StatusPageFooter = ({className}: {className?: string}) => (
  // "powered-by" is a stable hook so customer CSS can hide/restyle the watermark.
  <footer className={classNames(styles.footer, className, "powered-by")}>Powered by Uptime.com Status Page</footer>
);
